// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header___G3-h","content":"ManualTimeModal_content__1c8GE"};